import React from 'react';

function FormatDateTime({ isoDateString }) {
  // Check if the date string is valid
  if (!isoDateString) {
    return <span className="text-muted">No date</span>;
  }

  const date = new Date(isoDateString);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return <span className="text-muted">Invalid date</span>;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amPm = hours >= 12 ? 'PM' : 'AM';
  const adjustedHours = hours % 12 || 12;

  return (
    <div className='d-flex gap-1'>
      <small>{`${month}/${day}/${year}`}</small>
      <small>at</small>
      <small>{`${adjustedHours}:${minutes} ${amPm}`}</small>
    </div>
  );
}

export default FormatDateTime;